import axios from 'axios';

const api = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL_API
})

api.defaults.headers.post['Content-Type'] = 'application/json'

export default api;